import { render } from "./Leaders.vue?vue&type=template&id=61677fc7"
import script from "./Leaders.vue?vue&type=script&lang=js"
export * from "./Leaders.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__